/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import produce from 'immer';
import {createSelector} from 'reselect';
import {DialogType, SelectedGridDataProps} from './types';

// Selectors
const selectDialogs = ({dialogs}) => dialogs;
const selectDialogControl = (state, dialog) => selectDialogs(state)?.[dialog];

export const dialogControlSelector = createSelector([
  selectDialogControl,
  (_, dialog) => dialog
],
(dialogControl: DialogControl): DialogControl => dialogControl
);

// Redux
interface DialogAction {
  dialog: DialogType;
  show?: boolean;
  selectedGridData?: SelectedGridDataProps;
}

interface DialogControl {
  show?: boolean;
  selectedGridData?: SelectedGridDataProps;
};

export interface DialogControlState {
  [DialogType.BULK_ACTION_DIALOG]: DialogControl,
}

const OPEN_DIALOG        = 'OPEN_DIALOG';
const CLOSE_DIALOG       = 'CLOSE_DIALOG';
const SELECTED_GRID_DATA = 'SELECTED_GRID_DATA';

export const toggleDialog = (show = false, dialog: DialogType) => ({
  type : show ? OPEN_DIALOG : CLOSE_DIALOG,
  dialog
});

export const editSelectedGridData = (dialog, selectedGridData) => ({
  type : SELECTED_GRID_DATA,
  dialog,
  selectedGridData
});

const initialState: DialogControlState = {
  [DialogType.BULK_ACTION_DIALOG] : {
    show : false
  }
};

const reducers = {
  [OPEN_DIALOG] : (draft: DialogControlState, {dialog}: DialogAction) => {
    draft[DialogType[dialog]].show = true;
  },
  [CLOSE_DIALOG] : (draft: DialogControlState, {dialog}: DialogAction) => {
    draft[DialogType[dialog]].show = false;
  },
  [SELECTED_GRID_DATA] : (draft: DialogControlState, {dialog, selectedGridData}: DialogAction) => {
    draft[DialogType[dialog]].selectedGridData = selectedGridData;
  }
};

export default produce((draft: DialogControlState = initialState, action) => {
  reducers?.[action.type]?.(draft, action);
  return draft;
});
